import React from 'react';

import { StyledTotalsSummary } from './TotalsSummary.styles';

import { TotalsSummaryProps } from './TotalsSummary.types';

const TotalsSummary = ({
  totalList,
  componentClassname = 'total-summary',
  customClassnames = '',
  customStyle = '',
}: TotalsSummaryProps) => {
  if (!totalList.length) return null;
  return (
    <StyledTotalsSummary
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
    >
      <div className={`${componentClassname}__list`}>
        {totalList.map((total, index) => (
          <div
            key={total.id ?? index}
            className={`${componentClassname}-line ${
              total.classname ? total.classname : ''
            } ${
              total.variant
                ? `${componentClassname}-line--is-${total.variant}`
                : ''
            }`}
          >
            <div className={`${componentClassname}-line__label`}>
              {total.label}
            </div>
            <div className={`${componentClassname}-line__price`}>
              {total.value}
            </div>
          </div>
        ))}
      </div>
    </StyledTotalsSummary>
  );
};
TotalsSummary.displayName = 'TotalsSummary';

export default TotalsSummary;
